<template>
    <div v-if="stats.length">
        <label class="form__control">
            <span class="form__select-container form__select-shortwrap">
                <select class="form__select--fill" v-model="numberOfDays" @change="getStats">
                    <option v-for="day in days" :key="day" :value="day">
                        {{ option(day) }}
                    </option>
                </select>
                <span class="form__select-icon"></span>
            </span>
        </label>

        <div class="heading-wrap">
            <h2 class="form__legend">{{ region }}</h2>
        </div>

        <ul class="stats__items">
            <UserStatisticsItem v-for="stat in regionStats" :key="stat.key" v-bind="stat" />
        </ul>

        <div class="heading-wrap">
            <h2 class="form__legend">{{ globalTitle }}</h2>
        </div>

        <ul class="stats__items">
            <UserStatisticsItem v-for="stat in globalStats" :key="stat.key" v-bind="stat" />
        </ul>
    </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue';
import UserStatisticsItem from './UserStatisticsItem.vue';
import { getStatistics } from '../api/index';

const props = defineProps({
    days: {
        type: Array,
        required: true,
    },
    globalTitle: {
        type: String,
        required: true,
    },
    daysLabel: {
        type: String,
        required: true,
    },
});

const stats = ref([]);
const numberOfDays = ref(7);
const region = ref('');

const getStats = async () => {
    try {
        const { data } = await getStatistics(numberOfDays.value);
        stats.value = data.data.statistics;
        region.value = data.data.region;
    } catch (error) {
        console.error(error);
    }
};

const regionStats = computed(() => stats.value.filter((s) => s.region));
const globalStats = computed(() => stats.value.filter((s) => !s.region));

const option = (day) => props.daysLabel.replace(':days', day);

getStats();
</script>
